import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { z } from 'zod';

import {
  GetCompImagesError,
  GetCompImagesVariables,
  fetchGetCompImages,
} from '../toolkitComponents.js';
import { queryKeyFn, useToolkitContext } from '../toolkitContext.js';
import { Registry } from './registry.js';

type Response = z.infer<typeof schema>;
const { schema } = Registry.getCompImages;

export function useGetCompImages(
  variables: GetCompImagesVariables,
  opts?: UseQueryOptions<Response, GetCompImagesError>,
): UseQueryResult<Response> {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<Response, GetCompImagesError>(
    queryKeyFn({
      path: '/api/v2/compImages/{id}',
      operationId: 'getCompImages',
      variables,
    }),
    async () => {
      const res = await fetchGetCompImages({ ...fetcherOptions, ...variables });
      return schema.parse(res);
    },
    opts,
  );
}
